import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<['header', 'cta', 'reasonsModalMessage']> =
	defineContent({
		default: {
			header: {
				id: 'growth.recommendation-jpd.product-name.header',
				description: 'Header for Jira Product Discovery recommendation message in Jira Side Nav',
				defaultMessage: 'Transform insights into action plans',
				role: 'title',
			},
			cta: {
				id: 'growth.recommendation-jpd.cta.label',
				description: 'CTA text for Jira Product Discovery recommendation message in Jira Side Nav',
				defaultMessage: 'Try Jira Product Discovery',
			},
			reasonsModalMessage: {
				id: 'growth.recommendation-jpd.reasons-modal.message',
				defaultMessage:
					"We think {jpd} will improve your team's productivity. The recommendation is based on:",
				description:
					'Explanation of why we think the JPD recommendation will be relevant to the customer.',
				role: 'description',
			},
		},
	});
